define(function (require) {
    function tmplFunc (string, data) {
        var _str = string;
        $.each(data, function (key, value) {
            _str = _str.replace(new RegExp('{{' + key + '}}', 'g'), value);
        });
        return _str;
    }

    var $ = require('jquery'),
        ie6 = !-[1] && !window.XMLHttpRequest,
        body = $('body'),
        headerHeight = 50,
        tmpl = [
            "<div id='dialog'>",
            "<div class='d-header'>",
            "<h1 class='d-title'>{{title}}</h1>",
            "<a href='javascript:void(0)' class='d-h-btn iconfont d-h-btn-close' title='关闭'>&#xe618;</a>",
            '</div>',
            "<div class='d-body'>{{html}}</div>",
            '</div>'
        ].join(''),
        allDialogs = {},
        defaultOptions = {
            width: 500,
            height: 400,
            title: '这是title',
            html: '这是测试', //  弹出层内容
            destroyOnClose: false, //  如果为TRUE则在点击关闭的时候销毁弹出层对象，否则隐藏弹出层
            onOpen: null, //	弹出层事件，在显示前触发
            onClose: null, //  弹出层事件，在关闭前触发
            onInit: null //  弹出层事件，在初始化完成之后触发
        },
        baseIndex = 1000;

    function zIndex () {
        return baseIndex++;
    }

    function Dialog (options) {
        var that = this;
        that.cache = {};
        that.id = new Date().getTime();
        that.isDetroyed = false;
        that.options = $.extend(false, defaultOptions, options);
        that.overlay = $("<div class='overlay'>").appendTo(body);
        // IE6 需要加一个iframe 的层来阻挡 IE6 select 穿透的问题
        if (ie6) {
            that.overlay2 = $("<iframe class='overlay'>").appendTo(body);
        }
        that.domDialog = $(tmplFunc(tmpl, that.options)).appendTo(body);
        that.domBody = that.domDialog.find('.d-body');
        that.domClose = that.domDialog.find('.d-h-btn-close');
        that.domDialog.css({
            width: that.options.width,
            height: that.options.height,
            marginLeft: -(that.options.width / 2),
            marginTop: -(that.options.height / 2)
        });
        that.domBody.css({
            height: that.options.height - headerHeight
        });

        that.domClose.on('click', function () {
            if (that.destroyOnClose) {
                that.destroy();
            } else {
                that.close();
            }
        });

        if (typeof that.options.onInit === 'function') {
            that.options.onInit.call(that, that, that.domBody);
        }

        allDialogs[that.id] = that;
    }

    Dialog.prototype = {
        /*
			弹出层显示
		*/
        open: function () {
            // onOpen 事件存在就执行， 如果执行返回为false， 则拒绝打开弹出层
            if (
                typeof this.options.onOpen === 'function' &&
                this.options.onOpen.call(this, this, this.domBody) === false
            ) {
                return;
            }
            var that = this;
            that.goTop();
            that.overlay.show();
            that.domDialog.css('top', '50%');
            ie6 && this.overlay2.show();
            body.addClass('scrub');
        },
        /*
			弹出层隐藏
		*/
        close: function () {
            var that = this;

            // onclose 事件存在就执行， 如果执行返回为false， 则拒绝关闭弹出层
            if (
                typeof that.options.onClose === 'function' &&
                that.options.onClose.call(that, that, that.domBody) === false
            ) {
                return;
            }

            that.overlay.hide();
            that.domDialog.css('top', '-100%');
            ie6 && this.overlay2.hide();
            body.removeClass('scrub');
        },
        onlyClose: function () {
            var that = this;

            that.overlay.hide();
            that.domDialog.css('top', '-100%');
            ie6 && this.overlay2.hide();
            body.removeClass('scrub');
        },
        /*
			弹出层销毁DOM
		*/
        destroy: function () {
            if (this.isDetroyed === false) {
                var that = this;
                // onclose 事件存在就执行， 如果执行返回为false， 则拒绝关闭弹出层
                if (
                    typeof that.options.onClose === 'function' &&
                    that.options.onClose.call(that, that, that.domBody) ===
                        false
                ) {
                    return;
                }

                this.overlay.remove();
                this.domDialog.remove();
                if (ie6) {
                    this.overlay2.remove();
                }
                this.clean();
                this.isDetroyed = true;
                delete allDialogs[this.id];
            }
        },
        onlyDestroy: function () {
            if (this.isDetroyed === false) {
                this.overlay.remove();
                this.domDialog.remove();
                if (ie6) {
                    this.overlay2.remove();
                }
                this.clean();
                this.isDetroyed = true;
                delete allDialogs[this.id];
            }
        },
        /*
			弹出层销毁对象
		*/
        clean: function () {
            var that = this;
            $.each(that, function (key, val) {
                if (Object.hasOwnProperty.call(that, key)) {
                    delete that[key];
                }
            });
        },
        /*
			重新设置标题
		*/
        setTitle: function (title) {
            this.domDialog.find('.d-title').text(title);
        },
        /*
			重新设置内容
		*/
        setHtml: function (html) {
            this.domBody.html(html);
        },
        /*
			重新设置弹出层的zIndex，让它浮在最前
		*/
        goTop: function () {
            this.overlay.css({ zIndex: zIndex() });
            ie6 && this.overlay2.css({ zIndex: zIndex() });
            this.domDialog.css({ zIndex: zIndex() });
        }
    };

    return {
        /*
			@param:options 	弹出层初始化的必须参数
			@return 		弹出层对象
		*/
        init: function (options) {
            return new Dialog(options);
        },
        /*
			@param:text 提示内容
			@param:onOK 点击确定时触发
		*/
        alert: (function () {
            var dialog = null;
            var tmpl = [
                "<div class='d-b-alert'>",
                "<div class='d-text'><p>{{text}}</p></div>",
                "<div class='d-operate'><a href='javascript:void(0)' class='btn d-custom-ok' style>确定</a></div>",
                '</div>'
            ].join('');
            return function (text, title, onOK, onCancel) {
                if (typeof title !== 'string') {
                    onOK = title;
                    onCancel = onOK;
                }
                if (dialog === null || dialog.isDetroyed === true) {
                    dialog = this.init({
                        width: 420,
                        height: 245,
                        title: typeof title === 'string' ? title : '提示',
                        onClose: function (dialog, body) {
                            if (
                                typeof dialog.cache.onCancel === 'function' &&
                                dialog.cache.onCancel.call(
                                    dialog,
                                    dialog,
                                    body
                                ) === false
                            ) {
                            }
                        },
                        onInit: function (dialog, body) {
                            body.on('click', '.d-custom-ok', function () {
                                if (
                                    typeof dialog.cache.onOK === 'function' &&
                                    dialog.cache.onOK.call(
                                        dialog,
                                        dialog,
                                        body
                                    ) === false
                                ) {
                                    return;
                                }
                                dialog.onlyClose();
                            });
                        }
                    });
                }
                dialog.cache.onOK = onOK;
                dialog.cache.onCancel = onCancel;
                dialog.setHtml(tmplFunc(tmpl, { text: text }));
                dialog.open();
                return dialog;
            };
        })(),
        /*
			@param:text 		提示内容
			@param:onOK 		点击确定时触发
			@param:onCancel 	点击取消和关闭时触发
		*/
        confirm: (function () {
            var dialog = null,
                tmpl = [
                    "<div class='d-b-confirm'>",
                    "<div class='d-text'><p>{{text}}</p></div>",
                    "<div class='d-operate'>",
                    "<a href='javascript:void(0)' class='btn d-custom-cancel'>{{cancelText}}</a>",
                    "<a href='javascript:void(0)' class='btn d-custom-ok' style='background-color: 	#DC143C;'>{{okText}}</a>",
                    '</div>',
                    '</div>'
                ].join(''),
                defaultOptions = {
                    cancelText: '取消',
                    okText: '确认'
                };
            return function (text, onOK, onCancel, options) {
                var _options = $.extend(
                    true,
                    { text: text },
                    defaultOptions,
                    options
                );
                if (dialog === null || dialog.isDetroyed === true) {
                    dialog = this.init({
                        width: 350,
                        height: 248,
                        title: '提示',
                        onClose: function (dialog, body) {
                            if (
                                typeof dialog.cache.onConfirmCancel ===
                                    'function' &&
                                dialog.cache.onConfirmCancel.call(
                                    dialog,
                                    dialog,
                                    body
                                ) === false
                            ) {
                                return false;
                            }
                        },
                        onInit: function (dialog, body) {
                            body.on('click', '.d-custom-ok', function () {
                                if (
                                    typeof dialog.cache.onConfirmOK ===
                                        'function' &&
                                    dialog.cache.onConfirmOK.call(
                                        dialog,
                                        dialog,
                                        body
                                    ) === false
                                ) {
                                    return;
                                }
                                dialog.onlyClose();
                            });
                            body.on('click', '.d-custom-cancel', function () {
                                if (
                                    typeof dialog.cache.onConfirmCancel ===
                                        'function' &&
                                    dialog.cache.onConfirmCancel.call(
                                        dialog,
                                        dialog,
                                        body
                                    ) === false
                                ) {
                                    return;
                                }
                                dialog.onlyClose();
                            });
                        }
                    });
                }
                dialog.cache.onConfirmOK = onOK;
                dialog.cache.onConfirmCancel = onCancel;
                dialog.setHtml(tmplFunc(tmpl, _options));
                dialog.open();
                return dialog;
            };
        })(),
        /*
			@param:label 		输入内容的标题
			@param:title 		输入弹出层的标题
			@param:placeholder 	输入弹出层的标题
			@param:onOK 		点击确定时触发
			@param:onCancel 	点击取消和关闭时触发
		*/
        prompt: (function () {
            var dialog = null;
            var tmpl = [
                "<div class='d-b-prompt'>",
                "<div class='d-form form-small'>",
                "<p class='label'>{{label}}</p>",
                "<div class='text-wrap'><textarea type='text' class='d-b-prompt-input' placeholder='{{placeholder}}'></textarea></div>",
                "<div class='row'><p class='error'></p></div>",
                '</div>',
                "<div class='d-operate'>",
                "<a href='javascript:void(0)' class='btn d-custom-cancel'>取消</a>",
                "<a href='javascript:void(0)' class='btn d-custom-ok'>确定</a>",
                '</div>',
                '</div>'
            ].join('');
            function setErrorText (text) {
                dialog.domBody.find('.error').html(text);
            }
            return function (label, placeholder, onOK, onCancel) {
                if (dialog === null || dialog.isDetroyed === true) {
                    dialog = this.init({
                        width: 350,
                        height: 270,
                        title: '提示',
                        onClose: function (dialog, body) {
                            if (
                                typeof dialog.cache.onPromptCancel ===
                                    'function' &&
                                dialog.cache.onPromptCancel.call(
                                    dialog,
                                    dialog,
                                    body,
                                    setErrorText
                                ) === false
                            ) {
                                return false;
                            }
                        },
                        onInit: function (dialog, body) {
                            body.on('click', '.d-custom-ok', function () {
                                if ($(this).hasClass('disable')) {
                                    return;
                                }
                                var value = body
                                    .find('.d-b-prompt-input')
                                    .val();
                                if (
                                    typeof dialog.cache.onPromptOK ===
                                        'function' &&
                                    dialog.cache.onPromptOK.call(
                                        dialog,
                                        value,
                                        dialog,
                                        body,
                                        setErrorText
                                    ) === false
                                ) {
                                    return;
                                }
                                dialog.onlyClose();
                            });
                            body.on('click', '.d-custom-cancel', function () {
                                if ($(this).hasClass('disable')) {
                                    return;
                                }
                                if (
                                    typeof dialog.cache.onPromptCancel ===
                                    'function'
                                ) {
                                    if (
                                        dialog.cache.onPromptCancel.call(
                                            dialog,
                                            dialog,
                                            body,
                                            setErrorText
                                        ) === false
                                    ) {
                                        return;
                                    }
                                }
                                dialog.onlyClose();
                            });
                        }
                    });
                }
                dialog.cache.onPromptOK = onOK;
                dialog.cache.onPromptCancel = onCancel;
                dialog.setHtml(
                    tmplFunc(tmpl, {
                        label: label,
                        placeholder: placeholder || ''
                    })
                );
                dialog.open();
                return dialog;
            };
        })(),
        /*
			全局显示 加载中的蒙版
		*/
        mask: (function () {
            var overlay = null;
            var mask = null;
            return {
                // 显示蒙版
                show: function () {
                    if (overlay === null) {
                        overlay = $("<div class='overlay'>").appendTo(body);
                        mask = $(
                            "<div class='mask'><i></i>正在努力加载中...</div>"
                        ).appendTo(body);
                    }
                    overlay.css({ zIndex: zIndex() });
                    mask.css({ zIndex: zIndex() });
                    overlay.show();
                    mask.show();
                },
                // 隐藏蒙版
                hide: function () {
                    if (overlay === null) {
                        overlay = $("<div class='overlay'>").appendTo(body);
                        mask = $(
                            "<div class='mask'><i></i>正在努力加载中...</div>"
                        ).appendTo(body);
                    }
                    overlay.fadeOut();
                    mask.fadeOut();
                }
            };
        })(),
        /*
		pjax 全局进度条
		*/
        progress: (function () {
            var progress = null;
            return {
                show: function (percent) {
                    if (progress === null) {
                        progress = $('<div id="pjax-progress"></div>').appendTo(
                            body
                        );
                    }
                    progress.show();
                    setTimeout(function () {
                        progress.css({
                            zIndex: zIndex(),
                            width: percent + '%',
                            opacity: 1
                        });
                    }, 0);
                },
                width: function (percent) {
                    if (progress === null) {
                        progress = $('<div id="pjax-progress"></div>').appendTo(
                            body
                        );
                    }
                    progress.css({ width: percent + '%' });
                },
                hide: function () {
                    if (progress === null) {
                        progress = $('<div id="pjax-progress"></div>').appendTo(
                            body
                        );
                    }
                    progress.hide();
                    progress.css({ width: '0%' });
                },
                fadeOut: function () {
                    if (progress === null) {
                        progress = $('<div id="pjax-progress"></div>').appendTo(
                            body
                        );
                    }
                    progress.css({ opacity: 0 });
                },
                fadeIn: function () {
                    progress.css({ opacity: 1 });
                }
            };
        })(),
        /*
		liushengjie新增的全局显示窗口,为中羽联用户绑定而写
		 @param:text 提示内容
		 @param:onOK 点击确定时触发
		 */
        zylBind: (function () {
            var dialog = null;
            var tmpl = [
                "<div class='d-b-alert'>",
                "<div class='d-text'><p>{{text}}</p></div>",
                '</div>'
            ].join('');
            return function (text, onOK, onCancel) {
                if (dialog === null || dialog.isDetroyed === true) {
                    dialog = this.init({
                        width: 480,
                        height: 480,
                        title: '请确认你的密码',
                        onClose: function (dialog, body) {
                            if (
                                typeof dialog.cache.onCancel === 'function' &&
                                dialog.cache.onCancel.call(
                                    dialog,
                                    dialog,
                                    body
                                ) === false
                            ) {
                                return '';
                            }
                        },
                        onInit: function (dialog, body) {
                            body.on('click', '.d-custom-ok', function () {
                                if (
                                    typeof dialog.cache.onOK === 'function' &&
                                    dialog.cache.onOK.call(
                                        dialog,
                                        dialog,
                                        body
                                    ) === false
                                ) {
                                    return;
                                }
                                dialog.onlyClose();
                            });
                        }
                    });
                }
                dialog.cache.onOK = onOK;
                dialog.cache.onCancel = onCancel;
                dialog.setHtml(tmplFunc(tmpl, { text: text }));
                dialog.open();
                return dialog;
            };
        })(),
        /*
			@return			获取全局zIndex计数
		*/
        zIndex: zIndex,
        /*
			清理所有的弹出层对象
		*/
        clear: function () {
            $.each(allDialogs, function (id, _dialog) {
                _dialog.destroy();
            });
        }
    };
});



// WEBPACK FOOTER //
// ./modules/dialog/0.0.0/dialog.js